module.exports = __webpack_public_path__ + "img/moody.4383c048.png";